import type { CollectionModel } from "@/features/collections/api/models/CollectionModel";
import { useCollectionHistoricalPositions } from "@/features/collections/api/useCollectionHistoricalPositions";
import { MarketValueDisplay } from "@/features/common/components/MarketValueDisplay";
import type { FC } from "react";

const CHART_BACKDROP_HISTORY_DAYS = 84;

export interface CollectionMarketValueDisplayProps {
	collection: CollectionModel;
}

export const CollectionMarketValueDisplay: FC<CollectionMarketValueDisplayProps> = props => {
	const { collection } = props;

	const historicalPositions = useCollectionHistoricalPositions(collection.collectionId, CHART_BACKDROP_HISTORY_DAYS);

	return (
		<MarketValueDisplay
			marketValue={collection.marketValue}
			invested={collection.invested}
			gain={collection.gain}
			historicalPositions={historicalPositions.data ?? []} />
	);
};
